import React from 'react';
import styled from 'styled-components';
import withSku from '@catalogo/service-americanas-product/src/hocs/sku';
import Options from './components/options';
import VariationText from './components/variationText';

export const SkuVariation = ({ productDiffs }) => {
  if (!productDiffs || productDiffs.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      {productDiffs.map(({ typeId, isAvailableOffer, textLabel, typeLabel, values }) => (
        <VariationSection key={typeId}>
          <VariationText
            isAvailableOffer={isAvailableOffer}
            textLabel={textLabel}
            typeLabel={typeLabel}
            typeId={typeId}
            isSkuTypeSize={typeId.toLowerCase().includes('tamanho')}
          />
          <Options values={values} />
        </VariationSection>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-size: 14px;
  margin-top: 9px;
  padding: 10px 0 15px;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;

  @media (min-width: 769px) {
    margin-top: 24px;
    padding: 0 0 22px;
  }
`;

const VariationSection = styled.div`
  margin-top: 6px;

  @media (min-width: 769px) {
    margin: 27px 0 2px;
  }
`;

export default withSku(SkuVariation);
